export default __webpack_public_path__ + "static/media/anthem-website-logos_glaad.ff3c8b62.webp";